import React from "react";
import Grid from "@mui/material/Grid";
export default function DetailLoanTemplate(props: any) {
    return (
        <Grid
            container spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            style={{ marginLeft: '0px', alignSelf: 'center', paddingTop: '39px' }}
            className="suppliersListDetailContent ">
            <span className="financialListDetailTitle" >
                سایر مشخصات طرح
            </span>
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} className="row" style={{ alignSelf: 'center', paddingBottom: '20px', paddingTop: '20px', paddingRight: "20px", lineHeight: '35px' }}>
                <Grid item xs={3} md={3} sm={3} style={{ paddingLeft: '0', paddingTop: '0' }}
                    borderLeft={{
                        lg: `${"1px solid #c1c7cb"}`,
                        md: `${"1px solid #c1c7cb"}`
                    }}
                    borderBottom={{ xs: "1px solid #c1c7cb", md: "none" }}
                    paddingX={".5rem"}
                    paddingY={{
                        xs: "1rem",
                        sm: "1rem",
                        md: "1rem",
                        lg: "0",
                        xl: "0",
                    }}
                // style={{
                //     position: "relative",
                //     display: "inline-block",
                //     lineHeight: "25px",
                //     paddingRight: "45px",
                //     paddingTop: "4vh",
                //     paddingBottom: "0.1vh",
                // }}
                >
                    <div>
                        <span style={{ color: "#9AAFC4" }}>نوع طرح فروش:</span>
                        <span style={{ color: "#34495E" }}>
                            {" "}
                            {props.data?.loanTemplateTypeTitle}
                        </span>
                    </div>
                    <div>
                        <span style={{ color: "#9AAFC4" }}>نوع مجوز افزایش اعتبار:</span>
                        <span style={{ color: "#34495E" }}>
                            {" "}
                            {props.data?.creditRequestPermissionTitle}
                        </span>
                    </div>
                    {/* <div>
                        <span style={{ color: "#9AAFC4" }}>درصد تسهیلات:</span>
                        <span style={{ color: "#34495E" }}>
                            {props.data?.maxLoanAmountBasedOnVehiclePricePercentage > 0 ?
                                <>
                                    {" "}
                                    %{props.data?.maxLoanAmountBasedOnVehiclePricePercentage}
                                </> :
                                "%0"
                            }

                        </span>
                    </div> */}

                </Grid>
                <Grid item xs={3} md={3} sm={3} style={{ paddingLeft: '0', paddingTop: '0px' }}
                    // style={{ height: '66%' }}
                    borderLeft={{
                        lg: `${"1px solid #c1c7cb"}`,
                        md: `${"1px solid #c1c7cb"}`
                    }}
                    borderBottom={{ xs: "1px solid #c1c7cb", md: "none" }}
                    paddingX={".5rem"}
                    paddingY={{
                        xs: "1rem",
                        sm: "1rem",
                        md: "1rem",
                        lg: "0",
                        xl: "0",
                    }}
                // className="divisionConfirmationCardFinancial"
                >
                    <div>
                        <span style={{ color: "#9AAFC4" }}>نوع بازپرداخت :</span>
                        <span style={{ color: "#34495E" }}>
                            {" "}
                            {props.data?.repaymentTypeTitle}
                        </span>
                    </div>
                    <div>
                        <span style={{ color: "#9AAFC4" }}>نرخ مالیات برارزش افزوده:</span>
                        <span style={{ color: "#34495E" }}>
                            {" "}
                            %{props.data?.governmentTaxPercent}

                        </span>
                    </div>
                </Grid>
                <Grid item xs={3} md={3} sm={3} style={{ paddingLeft: '0', paddingTop: '0px' }}
                    borderLeft={{
                        lg: `${"1px solid #c1c7cb"}`,
                        md: `${"1px solid #c1c7cb"}`
                    }}
                    borderBottom={{ xs: "1px solid #c1c7cb", md: "none" }}
                    paddingX={".5rem"}
                    paddingY={{
                        xs: "1rem",
                        sm: "1rem",
                        md: "1rem",
                        lg: "0",
                        xl: "0",
                    }}
                // style={{ height: '66%' }}
                // className="divisionConfirmationCardFinancial"
                >
                    <div>
                        <span style={{ color: "#9AAFC4" }}>سود اسمی تسهیلات:</span>
                        <span style={{ color: "#34495E" }}>
                            {props.data?.profitPercentage > 0 ?
                                <>
                                    {" "}
                                    %{props.data?.profitPercentage}
                                </> :
                                "..."
                            }
                        </span>
                    </div>
                    <div>
                        <span style={{ color: "#9AAFC4" }}>ارسال پیامک فعال سازی به مشتری:</span>
                        <span style={{ color: "#34495E" }}>
                            {" "}
                            {props.data?.needCustomerActivationLoanOtp}
                        </span>
                    </div>
                </Grid>
                {/* <Grid item xs={3} md={3} sm={3} style={{ paddingLeft: '0', paddingTop: '0px' }}
                    paddingX={".5rem"}
                    paddingY={{
                        xs: "1rem",
                        sm: "1rem",
                        md: "1rem",
                        lg: "0",
                        xl: "0",
                    }}
                // className="divisionConfirmationCardFinancial"
                >
                    <div>
                        <span style={{ color: "#9AAFC4" }}>سود واقعی تسهیلات:</span>
                        <span style={{ color: "#34495E" }}>
                            {props.data?.realProfitPercentage > 0 ?
                                <>
                                    {" "}
                                    %{props.data?.realProfitPercentage}
                                </> :
                                "..."

                            }

                        </span>
                    </div>


                </Grid> */}
            </Grid>

        </Grid>
    )
}